import React, { useState, useEffect, useRef, useMemo } from 'react'

const CITIZENSHIPS = [
  'Зимбабве','Замбия','Кения','Танзания','Уганда','Нигерия','Гана','Эфиопия','Камерун','Кот-д\'Ивуар',
  'Сенегал','Мали','Буркина-Фасо','Гвинея','Бенин','Того','Нигер','Чад','Судан','Руанда',
  'Бурунди','ДР Конго','Конго','Ангола','Мозамбик','Малawi','Ботсвана','Намибия','ЮАР',
  'Сомали','Эритрея','Джибути','Мадагаскар','Сейшелы','Маврикий','Кабо-Верде','Сьерра-Леоне','Либерия',
  'Филиппины','Индонезия','Вьетнам','Таиланд','Индия','Пакистан','Бангладеш','Шри-Ланка','Непал',
  'Мьянма','Камбоджа','Лаос','Монголия','Китай',
  'Колумбия','Перу','Боливия','Эквадор','Венесуэла','Бразилия','Аргентина','Чили','Парагвай','Уругвай',
  'Мексика','Куба','Доминиканская Республика','Гаити','Гватемала','Гондурас','Сальвадор','Никарагуа',
  'Россия','Украина','Беларусь','Молдова','Грузия','Армения','Азербайджан','Казахстан','Узбекистан',
  'Таджикистан','Кыргызстан','Туркменистан',
].sort()

const STATUS_IMPORT_MAP = {
  'ожидает': 'ожидает', 'ожидание': 'ожидает', 'waiting': 'ожидает', 'wait': 'ожидает', 'pending': 'ожидает',
  'в пути': 'в пути', 'в дороге': 'в пути', 'transit': 'в пути', 'in transit': 'в пути',
  'прибыл': 'прибыл', 'прибыла': 'прибыл', 'arrived': 'прибыл',
  'завершен': 'завершен', 'завершён': 'завершен', 'done': 'завершен', 'completed': 'завершен', 'finished': 'завершен',
}

function base64ToFile(b64, filename) {
  const ext = (filename.split('.').pop() || '').toLowerCase()
  const mimes = { jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', gif: 'image/gif', webp: 'image/webp', pdf: 'application/pdf' }
  const type = mimes[ext] || 'application/octet-stream'
  // Strip whitespace, fix URL-safe base64, add padding
  let clean = b64.replace(/\s/g, '').replace(/-/g, '+').replace(/_/g, '/')
  clean += '='.repeat((4 - clean.length % 4) % 4)
  const bytes = atob(clean)
  const arr = new Uint8Array(bytes.length)
  for (let i = 0; i < bytes.length; i++) arr[i] = bytes.charCodeAt(i)
  return new File([arr], filename, { type })
}

export function CitizenshipInput({ value, onChange, hasError }) {
  const [query, setQuery] = useState(value || '')
  const [open, setOpen] = useState(false)
  const ref = useRef(null)

  useEffect(() => { setQuery(value || '') }, [value])

  useEffect(() => {
    function handle(e) { if (ref.current && !ref.current.contains(e.target)) setOpen(false) }
    document.addEventListener('mousedown', handle)
    return () => document.removeEventListener('mousedown', handle)
  }, [])

  const filtered = useMemo(() => {
    if (!query) return CITIZENSHIPS
    const q = query.toLowerCase()
    return CITIZENSHIPS.filter(c => c.toLowerCase().startsWith(q)).concat(
      CITIZENSHIPS.filter(c => !c.toLowerCase().startsWith(q) && c.toLowerCase().includes(q))
    )
  }, [query])

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <input
        value={query}
        onChange={e => { setQuery(e.target.value); onChange(e.target.value); setOpen(true) }}
        onFocus={() => setOpen(true)}
        placeholder="Начните вводить..."
        style={{ width: '100%', fontSize: 13, padding: '6px 10px', borderRadius: 8, border: hasError ? '1.5px solid #E24B4A' : '1px solid #e0e0dc', boxSizing: 'border-box' }}
      />
      {open && filtered.length > 0 && (
        <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: 'white', border: '1px solid #e0e0dc', borderRadius: 8, boxShadow: '0 4px 16px rgba(0,0,0,0.1)', zIndex: 200, maxHeight: 200, overflowY: 'auto', marginTop: 2 }}>
          {filtered.map(c => (
            <div key={c} onMouseDown={() => { onChange(c); setQuery(c); setOpen(false) }}
              style={{ padding: '7px 12px', fontSize: 13, cursor: 'pointer', borderBottom: '0.5px solid #f5f5f3' }}
              onMouseOver={e => e.currentTarget.style.background = '#f5f5f3'}
              onMouseOut={e => e.currentTarget.style.background = 'transparent'}>
              {c}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
import { uploadRouteFile, fetchCities, addCity, fetchExpenseCategories, addExpenseCategory, deleteExpenseCategory, fetchAgents, fetchUserProfiles, fetchCandidates, sendSpecvisa, sendVisaIssued, sendVisaReceived, uploadPhoto } from '../lib/api'

const TIMEZONES = [
  { label: 'Харare (UTC+2)', value: 'Africa/Harare' },
  { label: 'Йоханнесбург (UTC+2)', value: 'Africa/Johannesburg' },
  { label: 'Аддис-Абеба (UTC+3)', value: 'Africa/Addis_Ababa' },
  { label: 'Найроби (UTC+3)', value: 'Africa/Nairobi' },
  { label: 'Москва (UTC+3)', value: 'Europe/Moscow' },
  { label: 'Дубай (UTC+4)', value: 'Asia/Dubai' },
  { label: 'Манила (UTC+8)', value: 'Asia/Manila' },
  { label: 'Гонконг (UTC+8)', value: 'Asia/Hong_Kong' },
  { label: 'Пекин (UTC+8)', value: 'Asia/Shanghai' },
  { label: 'Берлин (UTC+1/+2)', value: 'Europe/Berlin' },
  { label: 'Лондон (UTC+0/+1)', value: 'Europe/London' },
  { label: 'Нью-Йорк (UTC-5/-4)', value: 'America/New_York' },
]

function CityInput({ value, onChange, cities, onAddCity, placeholder }) {
  const [query, setQuery] = useState(value || '')
  const [open, setOpen] = useState(false)
  const [adding, setAdding] = useState(false)
  const [newTz, setNewTz] = useState('Africa/Harare')
  const ref = useRef(null)

  useEffect(() => { setQuery(value || '') }, [value])

  useEffect(() => {
    function handleClick(e) { if (ref.current && !ref.current.contains(e.target)) setOpen(false) }
    document.addEventListener('mousedown', handleClick)
    return () => document.removeEventListener('mousedown', handleClick)
  }, [])

  const filtered = cities.filter(c => c.name.toLowerCase().includes(query.toLowerCase()))
  const exactMatch = cities.some(c => c.name.toLowerCase() === query.toLowerCase())

  function select(city) {
    setQuery(city.name)
    onChange(city.name, city.timezone)
    setOpen(false)
    setAdding(false)
  }

  async function handleAdd() {
    if (!query.trim()) return
    const city = await onAddCity(query.trim(), newTz)
    if (city) select(city)
    setAdding(false)
  }

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <input value={query} onChange={e => { setQuery(e.target.value); setOpen(true) }} onFocus={() => setOpen(true)} placeholder={placeholder || '— начните вводить город —'} style={{ width: '100%', fontSize: 13, padding: '6px 10px', borderRadius: 8, border: '1px solid #e0e0dc', background: 'white' }} />
      {open && (
        <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: 'white', border: '1px solid #e0e0dc', borderRadius: 8, boxShadow: '0 4px 16px rgba(0,0,0,0.1)', zIndex: 100, maxHeight: 200, overflowY: 'auto', marginTop: 2 }}>
          {filtered.map(city => (
            <div key={city.id} onMouseDown={() => select(city)} style={{ padding: '8px 12px', fontSize: 13, cursor: 'pointer', borderBottom: '0.5px solid #f5f5f3' }} onMouseOver={e => e.target.style.background = '#f5f5f3'} onMouseOut={e => e.target.style.background = 'transparent'}>{city.name}</div>
          ))}
          {!exactMatch && query.trim() && (
            <div>
              {!adding ? (
                <div onMouseDown={() => setAdding(true)} style={{ padding: '8px 12px', fontSize: 12, color: '#378ADD', cursor: 'pointer', fontWeight: 500 }}>+ Добавить "{query}" в список</div>
              ) : (
                <div style={{ padding: '8px 12px' }}>
                  <div style={{ fontSize: 12, color: '#888', marginBottom: 4 }}>Часовой пояс для "{query}":</div>
                  <select value={newTz} onChange={e => setNewTz(e.target.value)} style={{ width: '100%', fontSize: 12, padding: '4px 8px', borderRadius: 6, border: '1px solid #e0e0dc', marginBottom: 6 }}>
                    {TIMEZONES.map(tz => <option key={tz.value} value={tz.value}>{tz.label}</option>)}
                  </select>
                  <div style={{ display: 'flex', gap: 6 }}>
                    <button type="button" onMouseDown={handleAdd} style={{ flex: 1, fontSize: 12, padding: '5px', borderRadius: 6, background: '#1a1a1a', color: 'white', border: 'none', cursor: 'pointer' }}>Добавить</button>
                    <button type="button" onMouseDown={() => setAdding(false)} style={{ fontSize: 12, padding: '5px 10px', borderRadius: 6, background: 'transparent', border: '1px solid #e0e0dc', cursor: 'pointer', color: '#888' }}>Отмена</button>
                  </div>
                </div>
              )}
            </div>
          )}
          {filtered.length === 0 && !query.trim() && <div style={{ padding: '8px 12px', fontSize: 12, color: '#bbb' }}>Начните вводить название города</div>}
        </div>
      )}
    </div>
  )
}

export default function CandidateModal({ mode, initialData, locations, onSave, onClose, isAdmin, currentUserId, currentUserName, isOperator }) {
  const [form, setForm] = useState({
    name: '', citizenship: '', city: '', passport: '', phone: '', questionnaire_text: '', passport_photos: [], visas: [], status: 'ожидает', location_id: locations[0]?.id || '', entry_date: new Date().toISOString().split('T')[0],
    responsible_id: (mode === 'add' && isOperator && currentUserId) ? currentUserId : '',
    responsible_name: (mode === 'add' && isOperator && currentUserName) ? currentUserName : '',
    flag: '', ...initialData,
  })
  const [route, setRoute] = useState(
    (initialData?.route && Array.isArray(initialData.route) && initialData.route.length > 0)
      ? initialData.route
      : [{ from: '', from_tz: 'Africa/Harare', from_date: '', from_time: '', to: '', to_tz: 'Africa/Harare', to_date: '', to_time: '', note: '', files: [] }]
  )
  const [cities, setCities] = useState([])
  const [operators, setOperators] = useState([])
  const [expenseCategories, setExpenseCategories] = useState([])
  const [agents, setAgents] = useState([])
  const [showAddCategory, setShowAddCategory] = useState(false)
  const [newCategoryName, setNewCategoryName] = useState('')
  const [newCategoryIcon, setNewCategoryIcon] = useState('📦')
  const [photoFile, setPhotoFile] = useState(null)
  const [photoPreview, setPhotoPreview] = useState(initialData?.photo_url || null)
  const [saving, setSaving] = useState(false)
  const [uploadingPoint, setUploadingPoint] = useState(null)
  const [showSpecvisa, setShowSpecvisa] = useState(false)
  const [specvisaEmbassy, setSpecvisaEmbassy] = useState('')
  const [specvisaSending, setSpecvisaSending] = useState(false)
  const [visaIssuedSending, setVisaIssuedSending] = useState(false)
  const [visaReceivedSending, setVisaReceivedSending] = useState(false)
  const [showVisaReceived, setShowVisaReceived] = useState(false)

  // Import state
  const [importUrl, setImportUrl] = useState('')
  const [importing, setImporting] = useState(false)
  const [importError, setImportError] = useState('')
  const [importHints, setImportHints] = useState({})
  const [importDuplicates, setImportDuplicates] = useState([])

  useEffect(() => {
    fetchCities().then(setCities).catch(console.error)
    fetchExpenseCategories().then(setExpenseCategories).catch(console.error)
    fetchAgents().then(setAgents).catch(console.error)
    fetchUserProfiles().then(data => { if (data) setOperators(data) }).catch(console.error)
  }, [])

  function set(field, value) { setForm(f => ({ ...f, [field]: value })) }

  function setRoutePoint(index, field, value, tz) {
    setRoute(r => r.map((p, i) => {
      if (i !== index) return p
      const updated = { ...p, [field]: value }
      if (field === 'from' && tz) updated.from_tz = tz
      if (field === 'to' && tz) updated.to_tz = tz
      return updated
    }))
  }

  function addPoint() {
    setRoute(r => [...r, { from: '', from_tz: 'Africa/Harare', from_date: '', from_time: '', to: '', to_tz: 'Africa/Harare', to_date: '', to_time: '', note: '', files: [] }])
  }

  function removePoint(index) {
    if (route.length === 1) return
    setRoute(r => r.filter((_, i) => i !== index))
  }

  function handlePhoto(e) {
    const file = e.target.files[0]
    if (!file) return
    setPhotoFile(file)
    setPhotoPreview(URL.createObjectURL(file))
  }

  async function handleFileUpload(e, pointIndex) {
    const files = Array.from(e.target.files)
    if (!files.length) return
    setUploadingPoint(pointIndex)
    try {
      const uploaded = await Promise.all(files.map(file => uploadRouteFile(file, initialData?.id || 'new_' + Date.now(), pointIndex)))
      setRoute(r => r.map((p, i) => i === pointIndex ? { ...p, files: [...(p.files || []), ...uploaded] } : p))
    } catch (e) { alert('Ошибка загрузки: ' + e.message) }
    setUploadingPoint(null)
  }

  function removeFile(pointIndex, fileIndex) {
    setRoute(r => r.map((p, i) => i === pointIndex ? { ...p, files: (p.files || []).filter((_, fi) => fi !== fileIndex) } : p))
  }

  async function handleAddCity(name, timezone) {
    try {
      const city = await addCity(name, timezone)
      setCities(prev => [...prev, city].sort((a, b) => a.name.localeCompare(b.name)))
      return city
    } catch (e) { alert('Ошибка: ' + e.message); return null }
  }

  async function handleAddCategory() {
    if (!newCategoryName.trim()) return
    try {
      const cat = await addExpenseCategory(newCategoryName.trim(), newCategoryIcon)
      setExpenseCategories(prev => [...prev, cat].sort((a, b) => a.name.localeCompare(b.name)))
      setNewCategoryName('')
      setShowAddCategory(false)
    } catch (e) { alert('Ошибка: ' + e.message) }
  }

  async function handleDeleteCategory(id) {
    if (!window.confirm('Удалить категорию?')) return
    try {
      await deleteExpenseCategory(id)
      setExpenseCategories(prev => prev.filter(c => c.id !== id))
    } catch (e) { alert('Ошибка: ' + e.message) }
  }

  async function handleImport() {
    const raw = importUrl.trim()
    if (!raw) return
    setImporting(true)
    setImportError('')
    setImportHints({})
    setImportDuplicates([])

    const url = raw.startsWith('http') ? raw : `https://base-joinrus.ru/api/export/${raw}`

    try {
      const res = await fetch(url)
      if (!res.ok) {
        if (res.status === 404 || res.status === 410) {
          setImportError('Ссылка недействительна, уже была использована или истекла')
        } else {
          setImportError(`Ошибка сервера: ${res.status}`)
        }
        setImporting(false)
        return
      }
      const data = await res.json()
      const hints = {}

      // проверка дублей по паспорту и телефону
      const dupes = []
      if (data.passport || data.phone) {
        const filters = []
        if (data.passport) filters.push(`passport=eq.${encodeURIComponent(data.passport)}`)
        if (data.phone) filters.push(`phone=eq.${encodeURIComponent(data.phone)}`)
        const allCands = await fetchCandidates()
        const existing = (allCands || []).filter(c => !c.archived && (
          (data.passport && c.passport === data.passport) ||
          (data.phone && c.phone === data.phone)
        ))
        if (existing.length > 0) dupes.push(...existing)
      }
      setImportDuplicates(dupes)

      // name = surname + name
      const fullName = [data.surname, data.name].filter(Boolean).join(' ').trim()
      if (fullName) set('name', fullName)

      // citizenship — match against fixed list
      if (data.citizenship_country) {
        const match = CITIZENSHIPS.find(c => c.toLowerCase() === data.citizenship_country.toLowerCase())
        if (match) {
          set('citizenship', match)
        } else {
          hints.citizenship = data.citizenship_country
        }
      }

      // free text fields
      if (data.passport) set('passport', data.passport)
      if (data.phone) set('phone', data.phone)
      if (data.city) set('city', data.city)

      // текущая локация — ищем по названию
      if (data.location_name) {
        const loc = locations.find(l => l.name.toLowerCase() === data.location_name.toLowerCase())
        if (loc) set('location_id', loc.id)
        else hints.location = data.location_name
      }

      // questionnaire: combine comment + application_text
      const parts = [data.comment, data.application_text].filter(Boolean)
      if (parts.length) set('questionnaire_text', parts.join('\n\n'))

      // status — match against fixed options
      if (data.status) {
        const mapped = STATUS_IMPORT_MAP[data.status.toLowerCase().trim()]
        if (mapped) {
          set('status', mapped)
        } else {
          hints.status = data.status
        }
      }

      // agent — match by name from DB
      if (data.agent_name) {
        const agent = agents.find(a => a.name.toLowerCase() === data.agent_name.toLowerCase())
        if (agent) {
          set('agent_id', agent.id)
          set('agent_name', agent.name)
        } else {
          hints.agent = data.agent_name
        }
      }

      setImportHints(hints)

      // files
      if (Array.isArray(data.files) && data.files.length > 0) {
        const passportUploads = []
        for (const f of data.files) {
          try {
            const file = base64ToFile(f.content_base64, f.filename)
            if (f.type === 'avatar') {
              setPhotoFile(file)
              setPhotoPreview(URL.createObjectURL(file))
            } else {
              const uploaded = await uploadRouteFile(file, 'import_' + Date.now(), 'passport')
              passportUploads.push(uploaded)
            }
          } catch (err) {
            console.error('Ошибка при обработке файла', f.filename, err)
          }
        }
        if (passportUploads.length > 0) {
          setForm(f => ({ ...f, passport_photos: [...(f.passport_photos || []), ...passportUploads] }))
        }
      }

    } catch (err) {
      if (err.name === 'TypeError') {
        setImportError('Не удалось подключиться к серверу-источнику. Проверьте ссылку или попробуйте позже.')
      } else {
        setImportError('Ошибка при импорте: ' + err.message)
      }
    }
    setImporting(false)
  }

  async function handleSubmit(e) {
    e.preventDefault()
    if (!form.name.trim()) return
    if (!form.responsible_id) { alert('Необходимо назначить ответственного'); return }
    setSaving(true)
    const cleanForm = { ...form, route }
    if (!cleanForm.responsible_id) cleanForm.responsible_id = null
    await onSave(cleanForm, photoFile)
    setSaving(false)
  }

  const inputStyle = { width: '100%', fontSize: 13, padding: '6px 10px', borderRadius: 8, border: '1px solid #e0e0dc', background: 'white' }
  const errBorder = '1.5px solid #E24B4A'

  function ImportHint({ field }) {
    if (!importHints[field]) return null
    return <div style={{ fontSize: 11, color: '#aaa', marginTop: 3 }}>из источника: «{importHints[field]}» — не найдено, выберите вручную</div>
  }

  return (
<div className="modal-backdrop" style={{ zIndex: 1100 }}>      <div className="modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{mode === 'add' ? 'Новый кандидат' : 'Редактировать кандидата'}</h2>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>
        <form onSubmit={handleSubmit} className="modal-form">

          {mode === 'add' && (
            <div style={{ background: '#f0f6ff', border: '1px solid #c5dbf5', borderRadius: 10, padding: '12px 14px', marginBottom: 16 }}>
              <div style={{ fontSize: 12, fontWeight: 600, color: '#185FA5', marginBottom: 8 }}>📥 Импорт из внешней системы</div>
              <div style={{ display: 'flex', gap: 8 }}>
                <input
                  value={importUrl}
                  onChange={e => setImportUrl(e.target.value)}
                  onKeyDown={e => e.key === 'Enter' && (e.preventDefault(), handleImport())}
                  placeholder="Вставьте ссылку https://base-joinrus.ru/api/export/..."
                  style={{ flex: 1, fontSize: 12, padding: '7px 10px', borderRadius: 8, border: '1px solid #c5dbf5', background: 'white', outline: 'none' }}
                />
                <button
                  type="button"
                  onClick={handleImport}
                  disabled={importing || !importUrl.trim()}
                  style={{ padding: '7px 16px', borderRadius: 8, border: 'none', background: importing || !importUrl.trim() ? '#c5dbf5' : '#378ADD', color: 'white', fontSize: 12, fontWeight: 600, cursor: importing || !importUrl.trim() ? 'default' : 'pointer', whiteSpace: 'nowrap' }}
                >
                  {importing ? '⏳ Загрузка...' : 'Импортировать'}
                </button>
              </div>
              {importError && (
                <div style={{ marginTop: 8, fontSize: 12, color: '#E24B4A', background: '#fff0f0', border: '1px solid #fcc', borderRadius: 6, padding: '6px 10px' }}>
                  ⚠️ {importError}
                </div>
              )}
              {Object.keys(importHints).length > 0 && !importError && (
                <div style={{ marginTop: 8, fontSize: 12, color: '#a06000', background: '#fffbf0', border: '1px solid #f5dfa0', borderRadius: 6, padding: '6px 10px' }}>
                  ⚠️ Некоторые поля не удалось заполнить автоматически — они подсвечены ниже. Выберите значения вручную.
                </div>
              )}
              {importDuplicates.length > 0 && (
                <div style={{ marginTop: 8, fontSize: 12, background: '#fff0f0', border: '1px solid #fcc', borderRadius: 6, padding: '8px 10px' }}>
                  <div style={{ fontWeight: 600, color: '#E24B4A', marginBottom: 4 }}>⚠️ Возможный дубль — такой кандидат уже есть в системе:</div>
                  {importDuplicates.map(d => (
                    <div key={d.id} style={{ color: '#c0392b', marginTop: 2 }}>
                      {d.name}{d.passport ? ` · паспорт: ${d.passport}` : ''}{d.phone ? ` · тел: ${d.phone}` : ''}{d.entry_date ? ` · добавлен: ${d.entry_date.split('T')[0].split('-').reverse().join('.')}` : ''}
                    </div>
                  ))}
                  <div style={{ color: '#888', marginTop: 4 }}>Форма заполнена — вы можете отменить или сохранить как нового кандидата.</div>
                </div>
              )}
            </div>
          )}

          <div className="form-section-label">Фото</div>
          <div className="photo-row">
            <div className="photo-preview-circle">
              {photoPreview ? <img src={photoPreview} alt="фото" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <span style={{ fontSize: 28, color: '#bbb' }}>👤</span>}
            </div>
            <label className="upload-label">
              <input type="file" accept="image/*" onChange={handlePhoto} style={{ display: 'none' }} />
              📤 Загрузить фото
            </label>
          </div>

          <div className="form-section-label">Личные данные</div>
          <label>Дата добавления *
            {mode === 'add' ? (
              <input required type="date" value={form.entry_date || ''} onChange={e => set('entry_date', e.target.value)} />
            ) : (
              <input type="date" value={form.entry_date || ''} disabled style={{ background: '#f5f5f3', color: '#888', cursor: 'not-allowed' }} />
            )}
          </label>
          <label>Полное имя * (Фамилия Имя)
            <input required value={form.name} onChange={e => set('name', e.target.value)} placeholder="Фамилия Имя Отчество" />
          </label>
          <label>Гражданство
            <CitizenshipInput value={form.citizenship} onChange={v => set('citizenship', v)} hasError={!!importHints.citizenship} />
            <ImportHint field="citizenship" />
          </label>
          <label>Город проживания
            <input value={form.city || ''} onChange={e => set('city', e.target.value)} placeholder="Гверу, Бинга, Квекве..." />
          </label>
          <label>Номер паспорта
            <input type="text" inputMode="text" autoComplete="off" value={form.passport} onChange={e => set('passport', e.target.value)} placeholder="GN123456" />
          </label>
          <label>Номер телефона
            <input value={form.phone || ''} onChange={e => set('phone', e.target.value)} placeholder="+263 77 123 4567" />
          </label>
          <label>Флаг
            <select value={form.flag || ''} onChange={e => set('flag', e.target.value || null)}>
              <option value="">— без флага —</option>
              <option value="🔴 Срочно">🔴 Срочно</option>
              <option value="🟡 Ожидание">🟡 Ожидание</option>
              <option value="🟢 Готов">🟢 Готов</option>
              <option value="🔵 VIP">🔵 VIP</option>
            </select>
          </label>
          <div className="row-2">
            <label>Статус
              <select value={form.status} onChange={e => set('status', e.target.value)} style={importHints.status ? { border: errBorder } : {}}>
                <option value="ожидает">Ожидает</option>
                <option value="в пути">В пути</option>
                <option value="прибыл">Прибыл</option>
                <option value="завершен">Завершен</option>
              </select>
              <ImportHint field="status" />
            </label>
            <label>Текущая локация
              <select value={form.location_id} onChange={e => set('location_id', e.target.value)}>
                {locations.map(l => <option key={l.id} value={l.id}>{l.name}</option>)}
              </select>
            </label>
          </div>
          <label>Ответственный
            <select value={form.responsible_id || ''} onChange={e => {
              const op = operators.find(o => o.id === e.target.value)
              set('responsible_id', e.target.value)
              set('responsible_name', op?.full_name || '')
            }}>
              <option value="">— не назначен —</option>
              {operators.filter((o, i, arr) => arr.findIndex(x => x.full_name === o.full_name) === i).map(o => <option key={o.id} value={o.id}>{o.full_name}</option>)}
            </select>
          </label>
          <label>Агент
            <select value={form.agent_id || ''} onChange={e => {
              const ag = agents.find(a => a.id === e.target.value)
              set('agent_id', e.target.value || null)
              set('agent_name', ag?.name || '')
            }} style={importHints.agent ? { border: errBorder } : {}}>
              <option value="">— не назначен —</option>
              {agents.map(a => <option key={a.id} value={a.id}>{a.name}{a.company ? ' (' + a.company + ')' : ''}</option>)}
            </select>
            <ImportHint field="agent" />
          </label>

          <div className="form-section-label">Анкета</div>
          <label>Ответы на вопросы анкеты
            <textarea value={form.questionnaire_text || ''} onChange={e => set('questionnaire_text', e.target.value)} placeholder="1. ответ&#10;2. ответ&#10;3. ответ..." rows={6} style={{ width: '100%', fontSize: 13, padding: '6px 10px', borderRadius: 8, border: '1px solid #e0e0dc', background: 'white', resize: 'vertical', fontFamily: 'inherit' }} />
          </label>

          <div className="form-section-label">Фото паспорта</div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 8 }}>
            {(form.passport_photos || []).map((f, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 6, background: '#fafaf8', border: '1px solid #efefec', borderRadius: 8, padding: '5px 10px', fontSize: 12 }}>
                <a href={f.url} target="_blank" rel="noreferrer" style={{ color: '#185FA5', textDecoration: 'none' }}>📄 {f.name}</a>
                <button type="button" onClick={() => set('passport_photos', (form.passport_photos || []).filter((_, fi) => fi !== i))} style={{ color: '#E24B4A', background: 'transparent', border: 'none', cursor: 'pointer', fontSize: 12 }}>✕</button>
              </div>
            ))}
          </div>
          <label style={{ display: 'inline-block', fontSize: 12, padding: '6px 12px', border: '1px dashed #d0d0cc', borderRadius: 7, cursor: 'pointer', color: '#888', marginBottom: 8 }}>
            📎 Прикрепить фото паспорта
            <input type="file" multiple accept="image/*,.pdf" onChange={async e => {
              const files = Array.from(e.target.files)
              const uploaded = await Promise.all(files.map(f => uploadRouteFile(f, initialData?.id || 'new_' + Date.now(), 'passport')))
              set('passport_photos', [...(form.passport_photos || []), ...uploaded])
            }} style={{ display: 'none' }} />
          </label>

          <div className="form-section-label">Расходы</div>
          {(form.expenses || []).length === 0 && <div style={{ fontSize: 12, color: '#999', marginBottom: 8 }}>Расходов нет. Добавьте через раздел «Расходы» в Личном кабинете.</div>}
          {(form.expenses || []).map((exp, ei) => (
            <div key={ei} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 10px', fontSize: 12, background: '#fafaf8', borderRadius: 8, marginBottom: 4 }}>
              <div>
                <div style={{ color: '#444', fontWeight: 500 }}>{exp.category || '—'}</div>
                {exp.date && <div style={{ fontSize: 11, color: '#aaa' }}>{exp.date.split('T')[0].split('-').reverse().join('.')}</div>}
                {exp.comment && <div style={{ fontSize: 11, color: '#999' }}>{exp.comment}</div>}
              </div>
              <span style={{ fontWeight: 600, color: '#1a1a1a', flexShrink: 0, marginLeft: 8 }}>{parseFloat(exp.amount || 0).toLocaleString('ru-RU')} ₽</span>
            </div>
          ))}
          {(form.expenses || []).length > 0 && (
            <div style={{ fontSize: 13, fontWeight: 600, color: '#639922', padding: '6px 10px', marginBottom: 8 }}>
              Итого: {(form.expenses || []).reduce((sum, e) => sum + (parseFloat(e.amount) || 0), 0).toLocaleString('ru-RU')} ₽
            </div>
          )}

          <div className="form-section-label">Маршрут</div>
          {route.length === 0 && <div style={{ fontSize: 12, color: '#999', marginBottom: 8 }}>Маршрут не указан. Добавьте поездку через раздел «Поездки» в Личном кабинете.</div>}
          {route.map((point, index) => (
            <div key={index} style={{ background: '#fafaf8', border: '1px solid #efefec', borderRadius: 10, padding: '10px 14px', marginBottom: 6, fontSize: 12 }}>
              <div style={{ fontWeight: 600, marginBottom: 4 }}>✈ {point.from || '—'} → {point.to || '—'}</div>
              {point.from_date && <div style={{ color: '#888' }}>Вылет: {String(point.from_date).slice(0,10).split('-').reverse().join('.')} {point.from_time || ''}</div>}
              {point.to_date && <div style={{ color: '#888' }}>Прилёт: {String(point.to_date).slice(0,10).split('-').reverse().join('.')} {point.to_time || ''}</div>}
              {point.note && <div style={{ color: '#888', fontStyle: 'italic', marginTop: 2 }}>💬 {point.note}</div>}
            </div>
          ))}

          {mode === 'edit' && (
            <div style={{ marginBottom: 12 }}>
              {!showSpecvisa ? (
                <button type="button" onClick={() => setShowSpecvisa(true)}
                  style={{ fontSize: 12, padding: '7px 14px', borderRadius: 8, border: '1px solid #e0a800', background: '#fff8e1', color: '#b8860b', cursor: 'pointer', fontWeight: 600 }}>
                  📤 Отправить на спецвизу
                </button>
              ) : (
                <div style={{ background: '#fff8e1', border: '1px solid #e0a800', borderRadius: 10, padding: 12 }}>
                  <div style={{ fontSize: 12, fontWeight: 600, color: '#b8860b', marginBottom: 8 }}>📤 Спецвиза → Лёне</div>
                  <input
                    value={specvisaEmbassy}
                    onChange={e => setSpecvisaEmbassy(e.target.value)}
                    placeholder="Посольство (напр. Бангладеш Дакка)"
                    style={{ width: '100%', fontSize: 13, padding: '7px 10px', borderRadius: 8, border: '1px solid #e0a800', boxSizing: 'border-box', marginBottom: 8 }}
                  />
                  <div style={{ display: 'flex', gap: 8 }}>
                    <button type="button" disabled={specvisaSending || !specvisaEmbassy.trim()} onClick={async () => {
                      setSpecvisaSending(true)
                      try {
                        await sendSpecvisa(initialData.id, specvisaEmbassy.trim(), currentUserName)
                        alert('✅ Отправлено Лёне!')
                        setShowSpecvisa(false)
                        setSpecvisaEmbassy('')
                      } catch(e) { alert('Ошибка: ' + e.message) }
                      finally { setSpecvisaSending(false) }
                    }} style={{ fontSize: 12, padding: '6px 14px', borderRadius: 8, border: 'none', background: '#e0a800', color: 'white', cursor: 'pointer', fontWeight: 600 }}>
                      {specvisaSending ? 'Отправка...' : 'Отправить'}
                    </button>
                    <button type="button" onClick={() => { setShowSpecvisa(false); setSpecvisaEmbassy('') }}
                      style={{ fontSize: 12, padding: '6px 12px', borderRadius: 8, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer', color: '#888' }}>
                      Отмена
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}

          {mode !== 'add' && initialData?.specvisa_sent_at && (
            <div style={{ marginBottom: 12, display: 'flex', flexDirection: 'column', gap: 8 }}>
              {!initialData.visa_issued_at ? (
                <button type="button" disabled={visaIssuedSending} onClick={async () => {
                  if (!window.confirm('Подтвердить: виза вышла?')) return
                  setVisaIssuedSending(true)
                  try {
                    await sendVisaIssued(initialData.id)
                    alert('✅ Отмечено: виза вышла. Уведомление отправлено.')
                    onClose()
                  } catch(e) { alert('Ошибка: ' + e.message) }
                  finally { setVisaIssuedSending(false) }
                }} style={{ fontSize: 12, padding: '7px 14px', borderRadius: 8, border: '1px solid #1565c0', background: '#e3f2fd', color: '#1565c0', cursor: 'pointer', fontWeight: 600 }}>
                  {visaIssuedSending ? 'Отправка...' : '📬 Виза вышла'}
                </button>
              ) : !initialData.visa_received_at ? (
                <div>
                  {!showVisaReceived ? (
                    <button type="button" onClick={() => setShowVisaReceived(true)}
                      style={{ fontSize: 12, padding: '7px 14px', borderRadius: 8, border: '1px solid #2e7d32', background: '#e8f5e9', color: '#2e7d32', cursor: 'pointer', fontWeight: 600 }}>
                      📸 Виза получена
                    </button>
                  ) : (
                    <div style={{ background: '#e8f5e9', border: '1px solid #2e7d32', borderRadius: 10, padding: 12 }}>
                      <div style={{ fontSize: 12, fontWeight: 600, color: '#2e7d32', marginBottom: 8 }}>📸 Виза получена — загрузить фото</div>
                      <input type="file" accept="image/*" onChange={async (e) => {
                        const file = e.target.files[0]
                        if (!file) return
                        setVisaReceivedSending(true)
                        try {
                          const url = await uploadPhoto(file, initialData.id)
                          await sendVisaReceived(initialData.id, url)
                          alert('✅ Виза получена! Уведомление с фото отправлено.')
                          onClose()
                        } catch(err) { alert('Ошибка: ' + err.message) }
                        finally { setVisaReceivedSending(false) }
                      }} style={{ marginBottom: 8 }} />
                      {visaReceivedSending && <div style={{ fontSize: 12, color: '#2e7d32' }}>Загрузка...</div>}
                      <button type="button" onClick={() => setShowVisaReceived(false)}
                        style={{ fontSize: 12, padding: '5px 12px', borderRadius: 8, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer', color: '#888' }}>
                        Отмена
                      </button>
                    </div>
                  )}
                </div>
              ) : null}
            </div>
          )}

          <div className="modal-actions">
            <button type="button" className="btn btn-outline" onClick={onClose}>Отмена</button>
            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? 'Сохранение...' : mode === 'add' ? 'Добавить' : 'Сохранить'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
